import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Formik, Form } from 'formik';
import { Container, Row, Col, Stack, Button, Spinner } from "react-bootstrap";
import { TODIS_FORM_DSC, TODIS_FORM_FIELD, TODIS_FORM_FIELD_MULTISELECT, TODIS_FORM_FIELD_OPTIONS_DESC } from "../../../../components/Forms";
import { BsCalendarMinusFill, BsExclamationCircleFill, BsPlusLg } from "react-icons/bs";
import { ORGANIZATION, TODIS_ORGANIZATION } from "../../../../.config/modals";
import { OrganizationsService } from "../../../../HttpService/OrganizationService";
import { AuxiliaryService } from "../../../../HttpService/AuxiliaryService";
import Swal from "sweetalert2";
import style from "../Organizations.module.scss";
import { LOADING } from "../../../../components/Loading/Loading";

const FormOrganization = forwardRef((props, ref) => {

    const initialState = "create"
    const [loading, setLoading] = useState(false)
    const [typeAction, setTypeAction] = useState(initialState)
    const [initValue, setInitValue] = useState(ORGANIZATION)
    const [roles, setRoles] = useState([])
    const [regionals, setRegionals] = useState([])
    const [responseD, setResponseD] = useState(true)
    
    const getDataSelect = async() => {
        try {
            const auxiliaries = await new AuxiliaryService("auxData/regionalpartner").getAuxiliaries();
    
            auxiliaries.map(item => {
                if(item.txtNameTable == "regionalpartner")
                    setRegionals(item.auxtableDetailsDTOList)
            })
        } catch (error) {
            console.log("error listing selects", error);
        }
    }

    const getRoles = async() => {
        try {
            return await new OrganizationsService("role/roles/summary").getDataOrganizations();

        } catch (error) {
            console.log("error listing roles", error);
        }
    }

    const onCreate = async (values, {resetForm}) => {
        let roles = [];
        let rp = [];
        setLoading(true)
        try {
            values.roles.map(item => roles.push(item.value))
            values.regionalPartners.map(item => rp.push(item.value));
            const res = await new OrganizationsService("organization/create").createOrganization({ ...values, regionalPartners: rp, roles: roles });
            if (res.status == 201) {
                resetForm();
                setLoading(false)
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully created Organization',
                    showConfirmButton: false,
                    timer: 1500
                    })
                props.refreshList()
            } else {
                console.log("error in create Organization", res);
            }
        } catch (error) {
            console.log("error in create Organization", error);
        }
    }

    const onUpdate = async (values) => {
        
        setLoading(true)
        let roles = [];
        let rp = [];
        try {
            values.roles.map(item => roles.push(item.value ? item.value : item.id))
            values.regionalPartners.map(item => rp.push(item.value ? item.value : item.id));
            //console.log("roles: ", roles)
            //console.log("regionalPartners: ", rp)

            const res = await new OrganizationsService("organization/update").updateOrganization({ ...values,  regionalPartners: rp, roles: roles });
            if (res.status == 201) {
                setInitValue(ORGANIZATION)
                setTypeAction(initialState)
                setLoading(false)
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully updated Organization',
                    showConfirmButton: false,
                    timer: 1500
                    })
                props.refreshList()
            } else {
                console.log("error in update Organization", res);
            }
        } catch (error) {
            console.log("error in update Organization", error);
        }
    }

    const detailOrganization = async (id, typeAction) => {
        setLoading(true)
        try {
            const res = await new OrganizationsService("organization/organizations/" + id).getDetailsOrganization();
            if(res){
                setLoading(false)
                setInitValue(res)
                setTypeAction(typeAction)
            }
        } catch (error) {
            console.log("error in update Organization", error)
        }
    }

    useEffect(() => {
        (async () => {
            await getDataSelect();
            let resR = await getRoles();
            if(resR){
                setRoles(resR);
                setResponseD(false);
            } else {
                setResponseD(true)
            }
        })();
    }, []);

    useImperativeHandle(ref, () => ({
        detailOrganization
    }))

    return (
    <       Container fluid className="todis-form-wrapper p-4">
                <Row className="pb-3 pt-3" style={{overflow: "auto", maxHeight: "660px"}}>
                    <Col lg={12} className="ps-4">
                        <Stack gap={0}>
                            <h4 className="todis-header"><BsCalendarMinusFill className="me-3" />{typeAction == "create" ? "Create " : typeAction == "view" ? "Detail " : "Update "} Organization</h4>
                        </Stack>
                    </Col>
                </Row>
                {   
                !loading ?
                <Row>
                    <Formik
                        enableReinitialize={true}
                        initialValues={initValue}
                        validationSchema={TODIS_ORGANIZATION}
                        onSubmit={typeAction == "create" ? onCreate : onUpdate}>
                        {({ errors, touched, values, setFieldValue }) => (
                            <Form className="todis-form-content p-0">
                                <Container>
                                    <Row>
                                        <Col lg={12}>
                                            <TODIS_FORM_FIELD id="name" label="NAME" name="name" disabled={typeAction == "view"}/>
                                            {errors.name && touched.name ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.name}</div>) : null}
                                        </Col>
                                        <Col lg={12}>
                                            <TODIS_FORM_DSC id="description" label="DESCRIPTION" name="description" text="" style={{height: "auto"}} disabled={typeAction == "view"}></TODIS_FORM_DSC>
                                            {errors.description && touched.description ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.description}</div>) : null}
                                        </Col>
                                        <Col lg={12}>
                                            <TODIS_FORM_FIELD_MULTISELECT id="regionalPartners" label="REGIONAL PARTNER" name="regionalPartners" options={regionals} setFieldValue={setFieldValue} values={values} isLoading={false} disabled={typeAction == "view"}/>
                                            {errors.regionalPartners && touched.regionalPartners ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.regionalPartners}</div>) : null}
                                        </Col>
                                        <Col lg={12}>
                                            <TODIS_FORM_FIELD_MULTISELECT id="roles" label="ROLES" name="roles" options={roles} setFieldValue={setFieldValue} values={values} isLoading={responseD} disabled={typeAction == "view"}/>
                                            {errors.roles && touched.roles ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.roles}</div>) : null}
                                        </Col>
                                        <div className="todis-action-form">
                                            {
                                                typeAction == "view" || typeAction == "update" ?
                                                    <Button variant="outline-danger" onClick={() => { setInitValue(ORGANIZATION); setTypeAction("create")}} className={style.todisBtnOutline}>DISCARD </Button>
                                                    : null
                                            }
                                            {
                                                typeAction == "create" || typeAction == "update" ?
                                                    <Button variant="primary" className="todis-submit-btn bck-btn-secundary" type="submit" style={{margin: "0.5rem"}}>{typeAction == "create" && <BsPlusLg className="me-3" />}{typeAction.toUpperCase() + " ORGANIZATION" }</Button>
                                                : null
                                            }
                                        </div>
                                    </Row>
                                </Container>
                            </Form>
                        )}
                    </Formik>
                </Row> 
                :
                <LOADING/>
                }
            </Container>
    );
})

export default FormOrganization;